<template>
  <Tabs v-model="currentTab" :tabs="tabs" @change="setTab" />
  <div class="row mt-3">
    <div class="col">
      <p>Supply a VIN and Repair Order Number. When you do, the file uploader will appear. At that point, you can upload your Invoice scan.</p>
    </div>
  </div>
  <div class="row mt-2">
    <div class="col-6">
      <div class="input-group custom-input">
        <span class="input-group-text">VIN:</span>
        <input type="text" class="form-control custom-vin" v-model="vin" />
        <span class="input-group-text">RO Number:</span>
        <input type="text" class="form-control custom-id" v-model="id" />
      </div>
    </div>
    <div class="col-6"></div>
  </div>
  <div v-if="currentTab === 'Upload'" class="row mt-1">
    <div class="col">
      <FileUpload name="invoice" :firm="firm" :refId="id" :vin="vin" folder="invoices" @file-uploaded="fileUploaded" @analyze-file="analyzeFile" />
    </div>
    <div class="col"></div>
  </div>
  <div v-if="currentTab === 'Review'" class="row">
    <div class="col">
      <FilePreview :imageData="imageData" :isAnalyzing="isAnalyzing" @polygons-drawn="polygonsDrawn" />
    </div>
  </div>
</template>
<script>
import { mapState, mapActions } from 'pinia'
import { authStore } from '@/stores/auth'
import { fileStore } from '@/stores/file'
import { invoiceStore } from '@/stores/invoice'
import Tabs from '@/components/utilities/elements/Tabs.vue'
import FileUpload from '@/components/invoice/forms/file-upload.vue'
import FilePreview from '@/components/invoice/forms/file-preview.vue'
export default {
  name: 'InvoiceReview',
  components: {
    Tabs,
    FileUpload,
    FilePreview
  },
  data() {
    return {
      title: 'Invoice Review',
      currentTab: 'Upload',
      id: null,
      vin: null,
      imageData: null,
      isAnalyzing: false
    }
  },
  mounted() {
    this.isAnalyzing = false
    this.getFiles(this.firm)
  },
  computed: {
    ...mapState(authStore, ['profile']),
    tabs() {
      let _tabs = ['Upload', 'Review']
      return _tabs
    },
    firm() {
      let _firm = null
      if (this.profile) {
        _firm = this.profile.firm
      }
      console.log('firm', _firm)
      return _firm
    }
  },
  methods: {
    ...mapActions(fileStore, ['getFiles']),
    ...mapActions(invoiceStore, ['analyze']),
    setTab(value) {
      this.currentTab = value
    },
    fileUploaded() {
      console.log('file uploaded')
    },
    polygonsDrawn() {
      console.log('polygons drawn')
    },
    async analyzeFile(url) {
      console.log('analyze file', url)
      this.isAnalyzing = true
      await this.analyze(url)
      this.isAnalyzing = false
    }
  }
}
</script>
<style lang="scss" scoped>
.custom-input {
  margin-left: 10px;
}
.custom-id {
  max-width: 150px;
}
.custom-vin {
  max-width: 300px;
}
</style>
